import Alert from '@material-ui/lab/Alert';
import React from 'react';

function ExportWarning() {
  return (
    <Alert severity='warning' style={{ marginBottom: 16 }}>
      Atenção! A partir de 15/04/2025, a exportação de relatórios por e-mail estará restrita a endereços previamente autorizados. Você poderá enviar
      relatórios apenas para seu e-mail cadastrado e para os e-mails adicionados no controle de acesso.
    </Alert>
  );
}

export default ExportWarning;
